import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { SurveyComponent } from './product-health/survey/survey.component';
import { AuditComponent } from './product-health/audit/audit.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ConfigFormComponent } from '../../../my-shared-lib/src/lib/global-components/config-form/config-form.component';
import { SurveyRecordsAuditsComponent } from './survey-records-audits/survey-records-audits.component';

export const routes: Routes = [
  { path: 'chat', loadComponent: () => import('./chat/chat.component').then(module => module.ChatComponent) },
  {
    path: '',
    redirectTo: 'landing-page',
    pathMatch: 'full',
  },
  {
    path: 'user-history',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/user-history.json' },
  },
  {
    path: 'product-roadmap',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/product-roadmap.json' },
  },
  {
    path: 'historical-product-metrics',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/historical-product.json' },
  },
  {
    path: 'survey-data',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/audit-data.json' },
  },
  {
    path: 'landing-page',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'landing-page.json' },
  },
  {
    path: 'product-metrics',
    component: DashboardComponent,
    data: { configFile: 'product-health/product-metrics.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'survey',
    component: SurveyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'audit',
    component: AuditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'simulate',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/simulate.json' },
  },
  {
    path: 'simulate2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/simulate2.json' },
  },
  {
    path: 'impr-tracking-a-a',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/impr-tracking/impr-tracking.json' },
  },
  {
    path: 'impact-on-phi-a-a',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/impr-tracking/impact-on-phi.json' },
  },
  {
    path: 'project-list',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'current-projects/projectlist.json' },
  },
  {
    path: 'wave-project-list',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'current-projects/wave-project-list.json' },
  },
  {
    path: 'aop-mgmnt',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'current-projects/aop-mgmnt.json' },
  },
  {
    path: 'set-future-expectations',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-imprvmnt/impr-tracking/set-future-expectations.json' },
  },
  {
    path: 'spend-analysis-overall',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'current-projects/spend-analysis-summary-overall.json' },
  },
   {
    path: 'spend-analysis-detailed',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'current-projects/spend-analysis-summary-detailed.json' },
  },
  {
    path: 'spend-analysis-view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'current-projects/spend-analysis-view.json' },
  },
  {
    path: 'aop-planning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/aop-planning.json' },
  },
  {
    path: 'aop-planning-2026',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/aop-planning.json' },
  },
  {
    path: 'aop-planning-2027',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/aop-planning-2027.json' },
  },
  {
    path: 'sim-planning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/sim-planning.json' },
  },
  {
    path: 'sim-portfolio',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/sim-portfolio.json' },
  },
  {
    path: 'portfolio-gaps',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/portfolio-gaps.json' },
  },
  {
    path: 'aop-investment-summary',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/aop-investment-summary.json' },
  },
  {
    path: 'investment-return-summary',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/investment-return-summary.json' },
  },
  {
    path: 'ideas-hopper',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'ideation/ideas-hopper.json' },
  },
  {
    path: 'survey-records-audits',
    component: SurveyRecordsAuditsComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-health/survey-records-audits.json' },
  },
  {
    path: 'survey-records-audits-pm-rollup',
    component: SurveyRecordsAuditsComponent,
    canActivate: [AuthGuard],
    data: {
      configFile: 'product-health/survey-records-audits.json',
      defaultMode: 'rollup',
    },
  },

  {
    path: 'spend-effectiveness',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-imprvmnt/spend-effectiveness.json' },
  },
  {
    path: 'spend-allocation',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-imprvmnt/spend-allocation.json' },
  },
  {
    path: 'impr-tracking-a-e',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-imprvmnt/impr-tracking/impr-tracking.json' },
  },
  {
    path: 'impact-on-phi-a-e',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'product-imprvmnt/impr-tracking/impact-on-phi.json' },
  },
  {
    path: 'config',
    component: ConfigFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'survey-settings',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'settings/list-of-survey.json' },
  },

  {
    path: '**',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
];
